import { validator } from "@/utils/validator";

export const recoverSchema = validator.object().shape({
  email: validator.string().emptyToNull().max(60).label("メールアドレス").required(),
});
